import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {Settings} from "@/constants/settings";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ClanIntroPanel extends VerticalStandardPanel {

    private onAcceptCallback: (() => unknown) | undefined;

    constructor(scene: Scene, canvas: HTMLCanvasElement, available: boolean, onAcceptCallback: () => unknown) {
        super(scene, canvas, Tr('klan'));

        this.onAcceptCallback = onAcceptCallback;

        let nameText = TextUtils.addTextByFamily(scene, Tr('chto.takoe.klan'), 0, -170,
            '#ffd465', 18, 'bold', 450, Fonts.MYRIADPRO_REGULAR);

        let light = SpriteUtils.addSprite(this.scene, -135, -90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT);
        let icon = SpriteUtils.addSprite(this.scene, -150, -120, Keys.CLAN_BUILDING);

        let blockFirst = TextUtils.addTextAdvanced(scene, Tr('klan.eto.obedinenie.igrokov'), 55, -90,
            '#a2ff82', 15, 'normal', 280, 'center', 2, Fonts.ARIAL_MT);

        this.add([nameText, light, icon, blockFirst]);

        if (available) {
            let blockSecond = TextUtils.addTextByFamily(scene, Tr('klan.otkroet.novie.vozmozhnosti'),
                0, blockFirst.y / CU.S + 110, '#FFD465', 15, 'normal', 450, Fonts.ARIAL_MT);
            this.add(blockSecond);

            this.addCustomButton(-100, 150,Tr('zakrit'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, () => {});
            this.addCustomButton(100, 150,Tr('hochu.v.klan'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, onAcceptCallback);
        } else {
            let blockSecond = TextUtils.addTextByFamily(scene, Tr('vozmozhnost.vstupit.v.klan.otkroetsja.s') + String(Settings.CLAN_MIN_LEVEL) + Tr('go.level') + '.',
                0, blockFirst.y / CU.S + 105, '#ff9b65', 15, 'normal', 400, Fonts.ARIAL_MT);
            this.add(blockSecond);

            this.addCloseButton(Tr('horosho'), () => {});
        }

    }

    protected onClose(): void {

    }

}
